import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation updateHappeningMutation($input: UpdateHeroOfferInput!) {
    updateHeroOffer(input: $input) {
      heroOffer {
        id
        ...HappeningEdit_happening
        ...HappeningCell_happening
      }
      errors {
        key
        messages
      }
    }
  }
`;

const updateHappening = (environment, attributes, args = {}) => {
  const { backgroundImage, ...otherAttributes } = attributes;

  const uploadables = backgroundImage
    ? { happeningBackgroundImage: backgroundImage }
    : null;

  return commit(environment, {
    mutation,
    uploadables,
    variables: {
      input: otherAttributes,
    },
    optimisticResponse: {
      updateHeroOffer: {
        heroOffer: otherAttributes,
      },
    },
    ...args,
  });
};

export default updateHappening;
